export default "__VITE_ASSET__BR15znma__"